// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner___Vgz3aHN8","spinner-rotate":"spinner-rotate___MBKNKoNZ"};